import { AuthFactory } from "@shared/csa/auth";

// Create a singleton auth service instance
const authService = AuthFactory.createBrowser({
  ssoUrl: process.env.VUE_APP_CSA_SSO_URL,
  clientId: process.env.VUE_APP_CSA_SSO_CLIENT_ID,
  clientSecret: process.env.VUE_APP_CSA_SSO_CLIENT_SECRET,
  region: process.env.VUE_APP_CSA_SSO_REGION,
  grantType: process.env.VUE_APP_CSA_SSO_GRANT_TYPE,
  scope: process.env.VUE_APP_CSA_SSO_SCOPE,
  username: process.env.VUE_APP_CSA_USERNAME,
  password: process.env.VUE_APP_CSA_PASSWORD,
});

/**
 * Get the access token
 * @returns {Promise<string|null>} The access token or null if not available
 */
export async function getAccessToken() {
  return await authService.getAccessToken();
}

/**
 * Get the user ID
 * @returns {string|null} The user ID or null if not available
 */
export function getUserId() {
  return authService.getUserId();
}

/**
 * Get the username
 * @returns {string|null} The username or null if not available
 */
export function getUsername() {
  return authService.getUsername();
}

/**
 * Get a field from the token payload
 * @param {string} key - The field key
 * @returns {any} The field value
 */
export function getPayloadField(key) {
  return authService.getPayloadField(key);
}

export default authService;
